import { Module } from '@nestjs/common';
import { ConsultaRucController } from './consulta-ruc.controller';
import { ConsultaRucService } from './consulta-ruc.service';

@Module({
  controllers: [ConsultaRucController],
  providers: [ConsultaRucService],
  exports: [ConsultaRucService],
})
export class ConsultaRucModule {}
